import { render } from "./ScrollWrap.vue?vue&type=template&id=4f62764b&scoped=true&ts=true"
import script from "./ScrollWrap.vue?vue&type=script&lang=ts"
export * from "./ScrollWrap.vue?vue&type=script&lang=ts"

import "./ScrollWrap.vue?vue&type=style&index=0&id=4f62764b&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/ecom_ecom-offical-website_node_sharelib_cicd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f62764b"]])

export default __exports__